import { render, staticRenderFns } from "./MailToolbar.vue?vue&type=template&id=70cb0d2a"
import script from "./MailToolbar.vue?vue&type=script&lang=js"
export * from "./MailToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports